/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["main[_ngcontent-%COMP%]{min-height:auto!important}main[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{font-size:24px!important}main[_ngcontent-%COMP%]   .selfie-title[_ngcontent-%COMP%]{text-align:left;margin:0 auto;font-weight:300;color:#231d19}main[_ngcontent-%COMP%]   .content-checkbox[_ngcontent-%COMP%]{padding-top:10px;margin-bottom:20px}main[_ngcontent-%COMP%]   .content-checkbox[_ngcontent-%COMP%]     .voxel-radio__label{padding:.625rem 0}"];
export { styles as styles };
